module.exports = __webpack_public_path__ + "static/media/triangle.5da21d40.svg";